module.exports = __webpack_public_path__ + "static/img/title_img.36541a68.jpg";